import { render, staticRenderFns } from "./DsForm.vue?vue&type=template&id=e7b4b0a0&scoped=true&"
import script from "./DsForm.vue?vue&type=script&lang=js&"
export * from "./DsForm.vue?vue&type=script&lang=js&"
import style0 from "./DsForm.vue?vue&type=style&index=0&id=e7b4b0a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b4b0a0",
  null
  
)

export default component.exports